import { useState } from 'react';

import MLink from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";

import ModalDialogue from './ModalDialogue';

import ContextMenu from './ContextMenu.js';

import {
    RemoveCircle as RemoveCircleIcon,
    ThumbDown as ThumbDownIcon,
    ThumbUp as ThumbUpIcon
} from '@mui/icons-material';

import { Box, Button } from '@mui/material';
import { useAuthState } from '../../Context/context.js';

export default function UserListSingle(props) {
    const userDetails = useAuthState();
    
    const [deleteModal, setDeleteModal] = useState(false);

    const toggleDeleteModal = event => {
        setDeleteModal(!deleteModal);
    }

    var type = 'User'

    if( props.data.getRoles() && ( props.data.getRoles().includes('ROLE_ADMIN') ) )
    {
        type = 'Admin';
    }

    var options = [];

    if( props.onApprovedChange && !props.data.getApproved() )
    {
        options.push({icon: <ThumbUpIcon />, label: 'Approve User', onClick: () => {props.onApprovedChange(props.data.getId(), true)}});
        options.push({icon: <ThumbDownIcon />, label: 'Refuse User', onClick: () => {props.onApprovedChange(props.data.getId(), false)}});
    }
    else if( props.onDelete )
    {
        options.push({icon: <RemoveCircleIcon />, label: 'Deactivate User', onClick: toggleDeleteModal});
    }

    return (
        <TableRow key={props.data.getId()} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell sx={{width: '30%', paddingRight: 0}} component="th" scope="row">
                <Typography noWrap variant="body1">
                    {
                        ( userDetails.user.id === props.data.getId() ) ?
                            props.data.getName()
                        :
                            <MLink component={Link} to={`/users/${props.data.getId()}/edit`}>{props.data.getName()}</MLink>
                    }
                </Typography>
            </TableCell>
            <TableCell sx={{width: '35%', paddingRight: 0}}>
                <Typography noWrap variant="subtitle2">{props.data.getEmail()}</Typography>
            </TableCell>
            <TableCell sx={{width: '25%', paddingRight: 0}}>
                <Typography variant="subtitle2">{type}</Typography>
            </TableCell>
            <TableCell sx={{width: '10%', paddingRight: 0}}>
                <ModalDialogue showFooter={false} open={deleteModal} onClose={toggleDeleteModal}>
                    <Box sx={{px: 2, pt: 2, pb: 1}}>

                        <Typography mb={2} variant="h4">Deactivate User</Typography>
                        <Typography variant="body1">Are you sure you want to deactivate {props.data.getName()} ({props.data.getEmail()})'s account?.</Typography>

                        <Box sx={{textAlign: 'right'}}>
                            <Button
                                onClick={toggleDeleteModal}
                                sx={{mt: 2, ml: 2}}
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={() => {
                                    if( props.onDelete )
                                    {
                                        props.onDelete(props.data.getId()).then(deleteResponse => {
                                            toggleDeleteModal();
                                        });
                                    }
                                }}
                                sx={{mt: 2, ml: 2}
                            }>
                                Delete
                            </Button>
                        </Box>
   
                    </Box>
                </ModalDialogue>
                {
                    options &&
                        <ContextMenu
                            options={options}
                        />
                }
            </TableCell>
        </TableRow>
    );
}
